/**
 * ## print component
 *
 * @module src/components/print
 */

"use strict";

const conf = require("../../config");
const moment = require("moment-timezone");
const block = require("../block");
const l = require("../../common").localization;

const init = (kd) => {
  if (
    conf.vars.NODE_ENV.indexOf("ios") > -1 ||
    conf.vars.NODE_ENV.indexOf("android") > -1
  ) {
    cordova.plugins.printer.check((available, count) => {
      console.log(available, count);
    });
  }
};

const print = (div) => {
  if (
    conf.vars.NODE_ENV.indexOf("ios") > -1 ||
    conf.vars.NODE_ENV.indexOf("android") > -1
  ) {
    cordova.plugins.printer.print(document.getElementById(div), "index.html");
  } else {
    window.print();
  }
};

/**
 * print formatter for reservations.
 */
const reservations = (kd, resDate) => {
  const location = kd.doc("location")[0];
  let thisHTML = '<div style="font-family:Arial">';
  thisHTML += `<h1 style="font-weight: normal; font-size:26px; height: 34px;">\
        ${location.name}</h1>`;
  thisHTML += `<h1 style="font-size:22px; height: 60px;">${l.translate(
    "Reservations for"
  )} \
        ${l.tcal(
          moment(resDate * 1000).format(l.translate("dddd, MMMM Do YYYY"))
        )}</h1>`;
  thisHTML += `<div style="font-size: 12px; color: #999; float:left; width:7%">\
        ${l.translate("Time")}</div>`;
  thisHTML += `<div style="font-size: 12px; color: #999; float:left; width:5%; \
        text-align:center;">${l.translate("S")}</div>`;
  thisHTML += `<div style="font-size: 12px; color: #999; float:left; width:15%">\
        ${l.translate("Name")}</div>`;
  thisHTML += `<div style="font-size: 12px; color: #999; float:left; width:12%">\
        ${l.translate("Table(s)")}</div>`;
  thisHTML += `<div style="font-size: 12px; color: #999; float:left; width:18%">\
        ${l.translate("Phone")}</div>`;
  thisHTML += `<div style="font-size: 12px; color: #999; float:left; width:11%">\
        ${l.translate("Seat Pref")}</div>`;
  thisHTML += `<div style="font-size: 12px; color: #999; float:left; width:30%">\
        ${l.translate("Notes")}</div>`;
  thisHTML +=
    '<div style="font-size: 12px; float:none; clear:both; width:95%; ' +
    'height: 10px; border-bottom:1px solid #ddd; margin: 0 0 8px 0"></div>';
  const res = kd.where(
    "reservation",
    (obj) => {
      if (
        obj.date === resDate &&
        obj.status === 1 &&
        obj.requireConfirmation === 0
      ) {
        return true;
      }
    },
    "time"
  );
  for (let i = 0; i < res.length; ++i) {
    thisHTML += `<div style="font-size: 12px; float:left; width:7%">\
            ${block.indexToTime(res[i].time)}&nbsp;</div>`;
    thisHTML += `<div style="font-size: 12px; float:left; width:5%; text-align:center;">\
            ${res[i].size}&nbsp;</div>`;
    thisHTML += `<div style="font-size: 12px; float:left; width:15%;">\
            ${res[i].name}&nbsp;</div>`;
    thisHTML += `<div style="font-size: 12px; float:left; width:12%">\
            ${res[i].preSelect.join(", ")}&nbsp;</div>`;
    thisHTML += `<div style="font-size: 12px; float:left; width:18%">\
            ${block.formatCell(res[i].cell)}&nbsp;</div>`;
    let pref = res[i].preference;
    if (pref == l.translate("First Available")) {
      pref = l.translate("F/A");
    }
    thisHTML += `<div style="font-size: 12px; float:left; width:11%">\
            ${pref}&nbsp;</div>`;
    let notes = "";
    if (res[i].hasOwnProperty("customNotes") && res[i].customNotes) {
      notes += `${res[i].customNotes}, `;
    }
    res[i].notes.forEach((note) => {
      if (note.active) {
        notes += `${note.value}, `;
      }
    });
    notes.slice(0, -2);
    thisHTML += `<div style="font-size: 12px; float:left; width:30%">\
            ${notes}</div>`;
    thisHTML +=
      '<div style="font-size: 12px; float:none; clear:both; width:95%; ' +
      'height: 10px; border-bottom:1px solid #ddd; margin: 0 0 8px 0"></div>';
  }
  thisHTML += "</div>";
  $("#print_area").html(thisHTML);
  print("print_area");
};

/**
 * print formatter for chits. iOS and Android require direct styles attached to the divs.
 */
const create = (options, activity) => {
  let thisHTML = "";
  let quoted = 0;
  if (parseInt(activity.quoted, 10) <= 2) {
    quoted = 5;
  } else {
    quoted = parseInt(activity.quoted, 10) + 5;
  }
  let time24 = l.translate("h:mm a");
  if (options.location.time24) {
    time24 = "H:mm";
  }
  const now = `${moment().format(time24)}, ${moment().format(
    l.translate("MMM Do, YYYY")
  )}`;
  let notes = "";
  if (activity.hasOwnProperty("customNotes") && activity.customNotes) {
    notes += `${activity.customNotes}, `;
  }
  activity.notes.forEach((note) => {
    if (note.active) {
      notes += `${note.value}, `;
    }
  });

  notes.slice(0, -2);

  thisHTML +=
    '<div class="print_format" style="width: 260px; padding: 0px; ' +
    "text-align: center; display: block; color: #000; font-family: 'Arial', sans-serif;\">";

  switch (options.type) {
    case "waitlist": {
      const rtime = moment(parseInt(activity.statusTimes.added, 10) * 1000)
        .add(quoted, "minutes")
        .format(time24);
      if (activity.hasOwnProperty("res_id") && activity.res_id) {
        thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${l.translate("RESERVATION")}</div>`;
      } else {
        thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${l.translate("WALK-IN")}</div>`;
      }
      thisHTML += `<div class="chit_h1" style="font-weight:bold; font-size:22px;">\
${activity.name}</div>`;
      thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${l.translate("Party of")} ${activity.size}</div>`;
      thisHTML += `<div class="chit_h3" style="font-size:18px; border-bottom: 1px dotted #777;\
padding: 8px; margin: 8px 0px; width: 100%;">${l.translate(
        "Please return to the host at:"
      )}</div>`;
      thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${rtime}</div>`;
      thisHTML += `<div class="chit_footer" style=" font-size:12px; \
border-bottom: 1px solid #777; padding: 5px; margin: 60px 0 0 0;">\
${l.translate("Current Time:")} ${now}</div>`;
      break;
    }
    case "reservation": {
      thisHTML += `<div class="chit_h1" style="font-weight:bold; font-size:22px;">\
${activity.name}</div>`;
      thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${l.translate("RESERVATION")}</div>`;
      thisHTML += `<div class="chit_h2" >${l.translate("Party of")} ${
        activity.size
      }</div>`;
      thisHTML += `<div class="chit_h3" style="font-size:18px; border-bottom: 1px dotted #777;\
padding: 8px; margin: 8px 0px; width: 100%;">${notes}</div>`;
      thisHTML += `<div class="chit_footer" style=" font-size:12px; \
border-bottom: 1px solid #777; padding: 5px; margin: 60px 0 0 0;">\
${l.translate("Current Time:")} ${now}</div>`;
      break;
    }
    case "seated": {
      const rtime = moment(parseInt(activity.statusTimes.added, 10) * 1000)
        .add(quoted, "minutes")
        .format(time24);
      if (activity.hasOwnProperty("res_id") && activity.res_id) {
        thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${l.translate("SEATED / RESERVATION")}</div>`;
      } else {
        thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${l.translate("SEATED / WALK-IN")}</div>`;
      }
      thisHTML += `<div class="chit_h1" style="font-weight:bold; font-size:22px;">\
${activity.name}</div>`;
      thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${l.translate("Party of")} ${activity.size}</div>`;
      thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${l.translate("Table:")} ${activity.table}</div>`;
      thisHTML += `<div class="chit_h2" style="font-weight:bold; font-size:18px;">\
${l.translate("Section:")} ${activity.section}</div>`;
      thisHTML += `<div class="chit_h3" style="font-size:18px; border-bottom: 1px dotted #777;\
padding: 8px; margin: 8px 0px; width: 100%;">${notes}</div>`;
      thisHTML += `<div class="chit_footer" style=" font-size:12px; \
border-bottom: 1px solid #777; padding: 5px; margin: 60px 0 0 0;">\
${l.translate("Current Time:")} ${now}</div>`;
      break;
    }
    default: {
      break;
    }
  }

  thisHTML += "</div>";
  $("#print_area").html(thisHTML);
  print("print_area");
};

module.exports = {
  init,
  create,
  print,
  reservations,
};



/** WEBPACK FOOTER **
 ** ./src/components/print/index.js
 **/